// src/hooks/useUpdateResponsibleSinister.ts

import { useState } from "react";
import * as yup from "yup";
import { useToast } from "../../../shared/hooks";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";

interface Params {
	id: string;
	schema: yup.AnyObjectSchema;
	onSuccess?: (responsibleId: string) => void;
	setFormErrors?: (errors: Record<string, string>) => void;
}

export const useUpdateResponsibleSinister = ({ id, schema, onSuccess, setFormErrors }: Params) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isUploading, setIsUploading] = useState(false);
	const toastHandler = useToast();

	const handleUpdate = async (dados: { responsibleId: string }) => {
		setIsLoading(true);
		setIsUploading(true);

		try {
			const dadosValidados = await schema.validate(dados, { abortEarly: false });

			await SinisterService.updateResponsible(id, dadosValidados.responsibleId);

			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: "Responsável atualizado com sucesso",
			});

			onSuccess?.(dadosValidados.responsibleId);
		} catch (err: any) {
			if (err.name === "ValidationError" && setFormErrors) {
				const validationErrors: Record<string, string> = {};
				err.inner.forEach((error: yup.ValidationError) => {
					if (error.path) validationErrors[error.path] = error.message;
				});
				setFormErrors(validationErrors);
			} else {
				toastHandler.present({
					type: "error",
					position: "top-center",
					messageOrContent: err?.message ?? "Erro ao atualizar responsável",
				});
			}
		} finally {
			setIsLoading(false);
			setIsUploading(false);
		}
	};

	return {
		handleUpdate,
		isLoading,
		isUploading,
	};
};
